<template>
	 <v-container>
		 <v-dialog title="新增类型" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>新增数据类型</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						
						<v-col cols="12">
							<v-text-field :label="textLabel" v-model="add.sourceName" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"create-room",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			dataType:{
				type:String,
				default:""
			}
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if (newVal){
					this.add.sourceName = "";
					if (this.dataType == '1'){
						this.textLabel = "生源类型名称";
					}else if(this.dataType=='2'){
						this.textLabel = "就读学校名称";
					}else if(this.dataType=='3'){
						this.textLabel = "居住片区名称";
					}
				}
				
			},
			
		},
		data(){
			return {
				add: {
					sourceName:"",
				},
				hideShow:this.show,
				textLabel:"类型名称"
			}
		},
		mounted() {
			console.log("create-student-source mounted");
		},
		methods:{
			
			submitAdd(){
				
				if (!this.add.sourceName) {
					this.$noty.error('生源类型名称不能为空');
					return
				}
				const shopId = utils.getCurrentShopId();			
				// api
				const that = this;
				let url = `/edu/student/source/create`;
				let postData = {...this.add};
				postData.dataType = this.dataType;
				postData.shopId = shopId;
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");						
							this.$emit("success","");			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

<style>
</style>
